import { render, staticRenderFns } from "./TheProblemsList.vue?vue&type=template&id=b477dcfa&scoped=true"
import script from "./TheProblemsList.vue?vue&type=script&lang=js"
export * from "./TheProblemsList.vue?vue&type=script&lang=js"
import style0 from "./TheProblemsList.vue?vue&type=style&index=0&id=b477dcfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@7.0.0-bridge.0_@babel+core@7.26.7__cac_fzj6xqfhz2iur5pptcdfbzd24y/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b477dcfa",
  null
  
)

export default component.exports